import { SalaryComponent, NonPayableBenefitsComponentType, SalaryComponentSource, PerquisitesComponentType } from '../types';

export const EarningComponentsList: SalaryComponent[] = Array.from({ length: 25 }, (_, i) => {
  if (i % 3 === 0) {
    return {
      id: i.toString(),
      name: 'basic',
      description:
        'The basic salary is the base income of an employee, comprising of 35-50% of the total salary.',
      category: 'EARNINGS_CATEGORY',
      isActive: true,
      isPredefined: false,
      source: 'SALARY_STRUCTURE',
      settings: {
        behaviour: {
          pfBehaviour: { includeInPfWages: true },
          esiBehaviour: { includeInEsiWages: false },
          ptBehaviour: { includeInPtWages: false },
          lwfBehaviour: { includeInLwfWages: false },
          taxBehaviour: {
            taxExemptInOldRegime: true,
            taxExemptInNewRegime: false,
            taxExemptionSection: 'Section 10',
          },
          arrearBehaviour: {
            considerInArrear: false,
            allowNegative: false,
          },
          prorationBehaviour: {
            supportProration: true,
          },
          displayBehaviour: {
            showZero: false,
            visibleToEmployee: true,
            displayName: 'basic',
          },
        },
        earningDetails: {
          payType: 'fixed',
        },
      },
    };
  } else if (i % 3 === 1) {
    return {
      id: i.toString(),
      name: 'LTA',
      description:
        'Leave Travel Allowance (LTA) is a type of allowance that is provided by employers to employees to cover their travel expenses when they are on leave from work.',
      category: 'EARNINGS_CATEGORY',
      isActive: true,
      isPredefined: false,
      source: 'SALARY_STRUCTURE',
      settings: {
        behaviour: {
          pfBehaviour: { includeInPfWages: true },
          esiBehaviour: { includeInEsiWages: false },
          ptBehaviour: { includeInPtWages: false },
          lwfBehaviour: { includeInLwfWages: false },
          taxBehaviour: {
            taxExemptInOldRegime: true,
            taxExemptInNewRegime: false,
            taxExemptionSection: 'Section 10',
          },
          arrearBehaviour: {
            considerInArrear: false,
            allowNegative: false,
          },
          prorationBehaviour: {
            supportProration: true,
          },
          displayBehaviour: {
            showZero: false,
            visibleToEmployee: true,
            displayName: 'Leave Travel Allowance',
          },
        },
        earningDetails: {
          payType: 'fixed',
        },
      },
    };
  } else {
    return {
      id: i.toString(),
      name: 'HRA',
      description:
        'HRA is a component of the salary provided by the employer to the employee to meet the cost of living in rented accommodation.',
      category: 'EARNINGS_CATEGORY',
      isActive: false,
      isPredefined: false,
      source: 'SALARY_STRUCTURE',
      settings: {
        behaviour: {
          pfBehaviour: { includeInPfWages: false },
          esiBehaviour: { includeInEsiWages: true },
          ptBehaviour: { includeInPtWages: false },
          lwfBehaviour: { includeInLwfWages: false },
          taxBehaviour: {
            taxExemptInOldRegime: true,
            taxExemptInNewRegime: true,
            taxExemptionSection: 'Section 12',
          },
          arrearBehaviour: {
            considerInArrear: true,
            allowNegative: false,
          },
          prorationBehaviour: {
            supportProration: false,
          },
          displayBehaviour: {
            showZero: false,
            visibleToEmployee: true,
            displayName: 'Home Rent Allowance',
          },
        },
        earningDetails: {
          payType: 'fixed',
        },
      },
    };
  }
});

export const DeductionComponentsList: SalaryComponent[] = Array.from({ length: 25 }, (_, i) => {
  if (i % 2 === 0) {
    return {
      id: i.toString(),
      name: 'Basic',
      description:
        'The basic salary is the base income of an employee, comprising of 35-50% of the total salary.',
      category: 'DEDUCTIONS_CATEGORY',
      isActive: true,
      source: 'SALARY_STRUCTURE',
      settings: {
        behaviour: {
          pfBehaviour: { includeInPfWages: false },
          esiBehaviour: { includeInEsiWages: false },
          ptBehaviour: { includeInPtWages: false },
          lwfBehaviour: { includeInLwfWages: false },
          taxBehaviour: {
            taxExemptInOldRegime: true,
            taxExemptInNewRegime: false,
            taxExemptionSection: 'Section 10',
          },
          arrearBehaviour: {
            considerInArrear: false,
            allowNegative: false,
          },
          prorationBehaviour: {
            supportProration: false,
          },
          displayBehaviour: {
            showZero: false,
            visibleToEmployee: true,
            displayName: 'Basic',
          },
        },
        deductionDetails: {
          deductionType: 'ADHOC',
          deductFrom: 'GROSS_PAY',
        },
      },
    };
  } else {
    return {
      id: i.toString(),
      name: 'HRA',
      description:
        'HRA is a component of the salary provided by the employer to the employee to meet the cost of living in rented accommodation.',
      category: 'DEDUCTIONS_CATEGORY',
      isActive: false,
      source: 'SALARY_STRUCTURE',
      settings: {
        behaviour: {
          pfBehaviour: { includeInPfWages: false },
          esiBehaviour: { includeInEsiWages: true },
          ptBehaviour: { includeInPtWages: false },
          lwfBehaviour: { includeInLwfWages: false },
          taxBehaviour: {
            taxExemptInOldRegime: true,
            taxExemptInNewRegime: true,
            taxExemptionSection: 'Section 12',
          },
          arrearBehaviour: {
            considerInArrear: true,
            allowNegative: false,
          },
          prorationBehaviour: {
            supportProration: false,
          },
          displayBehaviour: {
            showZero: false,
            visibleToEmployee: true,
            displayName: 'Home Rent Allowance',
          },
        },
        deductionDetails: {
          deductionType: 'ADHOC',
          deductFrom: 'GROSS_PAY',
        },
      },
    };
  }
});

export const NonPayableBenefitsDummyData: NonPayableBenefitsComponentType[] = [
  {
    id: '1',
    name: 'Medical Insurance',
    description: 'Acko generlal insurance for all full-time employees',
    isActive: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'NON_PAYABLE_BENEFITS_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Medical Insurance'
        }
      },
      nonPayableBenefitsDetails: {
        isPartOfCTC: true,
        visibilityToEmployee: true
      }
    }
  },
  {
    id: '2',
    name: 'Gratuity',
    description: 'Statutory benefit paid to employees upon completion of 5 years of continuous service as per the Payment of Gratuity Act, 1972.',
    isActive: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'NON_PAYABLE_BENEFITS_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Gratuity'
        }
      },
      nonPayableBenefitsDetails: {
        isPartOfCTC: true,
        visibilityToEmployee: true
      }
    }
  },
  {
    id: '3',
    name: 'Gym membership',
    description: 'Corporate gym membership reimbursement up to ₹24,000 per year to promote employee health and wellness.',
    isActive: true,
    source: 'USER' as SalaryComponentSource,
    category: 'NON_PAYABLE_BENEFITS_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Gym membership'
        }
      },
      nonPayableBenefitsDetails: {
        isPartOfCTC: true,
        visibilityToEmployee: true
      }
    }
  },
  {
    id: '4',
    name: 'Car Allowance',
    description: 'Company-provided car benefit for eligible employees including maintenance, insurance, and fuel reimbursement for official travel.',
    isActive: true,
    source: 'USER' as SalaryComponentSource,
    category: 'NON_PAYABLE_BENEFITS_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Company Car'
        }
      },
      nonPayableBenefitsDetails: {
        isPartOfCTC: false,
        visibilityToEmployee: true
      }
    }
  }
];

export const PerquisitesDummyData: PerquisitesComponentType[] = [
  {
    id: '1',
    name: 'Rent-free accommodation',
    isActive: true,
    isPredefined: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'PERQUISITES_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Rent-free accommodation',
          description: 'Company provided accommodation without any rent deduction'
        },
      },
      perquisiteDetails: {
        isTaxable: true,
      }
    }
  },
  {
    id: '2',
    name: 'Stock Options',
    isActive: false,
    isPredefined: false,
    source: 'USER' as SalaryComponentSource,
    category: 'PERQUISITES_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Stock Options',
          description: 'Employee stock options as part of compensation package'
        },
      },
      perquisiteDetails: {
        isTaxable: true,
      }
    }
  },
  {
    id: '3',
    name: 'Car/Automotive',
    isActive: true,
    isPredefined: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'PERQUISITES_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Car/Automotive',
          description: 'Company provided vehicle for business and personal use'
        },
      },
      perquisiteDetails: {
        isTaxable: true,
      }
    }
  },
  {
    id: '4',
    name: 'Interest Free Loan',
    isActive: true,
    isPredefined: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'PERQUISITES_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Interest Free Loan',
          description: 'Interest-free loans provided by the company to employees'
        },
      },
      perquisiteDetails: {
        isTaxable: true,
      }
    }
  },
  {
    id: '5',
    name: 'Free Meals',
    isActive: true,
    isPredefined: true,
    source: 'DEFAULT' as SalaryComponentSource,
    category: 'PERQUISITES_CATEGORY',
    settings: {
      behaviour: {
        displayBehaviour: {
          displayName: 'Free Meals',
          description: 'Company provided meals during working hours'
        },
      },
      perquisiteDetails: {
        isTaxable: false,
      }
    }
  }
];
